"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "mt-5 mb-20" };
const _hoisted_2 = {
    key: 0,
    class: "grid gap-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
};
const _hoisted_3 = { class: "col-span-1 md:col-span-2 lg:col-span-3 text-center" };
const _hoisted_4 = ["onClick", "disabled"];
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Load More Articles", -1);
const _hoisted_6 = { key: 1 };
const _hoisted_7 = {
    key: 2,
    class: "text-center font-semibold"
};
const _hoisted_8 = {
    key: 3,
    class: "text-center font-semibold"
};
const vue_3 = require("vue");
const BlogPostPreview_vue_1 = __importDefault(require("./BlogPostPreview.vue"));
const ButtonIcon_vue_1 = __importDefault(require("../../../components/ButtonIcon.vue"));
const get_1 = __importDefault(require("lodash/get"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'BlogPostList',
    props: {
        postsUrl: {
            type: String,
            default: '/json/journal',
        },
    },
    setup(__props) {
        const props = __props;
        const posts = (0, vue_3.ref)([]);
        const loading_posts = (0, vue_3.ref)(false);
        const error = (0, vue_3.ref)(null);
        const page = (0, vue_3.ref)(1);
        const total = (0, vue_3.ref)(0);
        getPosts();
        function loadMore() {
            page.value++;
            getPosts();
        }
        function getPosts() {
            loading_posts.value = true;
            error.value = null;
            const params = {
                page: page.value,
            };
            fetch(props.postsUrl + '?' + new URLSearchParams(Object.entries(params)), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((response) => {
                posts.value.push(...(0, get_1.default)(response, 'data', []));
                total.value = (0, get_1.default)(response, 'meta.total', 0);
            })
                .catch((error) => {
                error.value = 'Error getting posts.';
            })
                .then(() => {
                loading_posts.value = false;
            });
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (posts.value.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(posts.value, (post) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BlogPostPreview_vue_1.default, {
                                key: post.slug,
                                post: post
                            }, null, 8, ["post"]));
                        }), 128)),
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (!loading_posts.value && total.value > posts.value.length)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 0,
                                    type: "button",
                                    onClick: (0, vue_2.withModifiers)(loadMore, ["prevent"]),
                                    class: "button has-icon button-outlined button-mutedpurple-800 hover:button-mutedpurple-700",
                                    disabled: loading_posts.value
                                }, [
                                    (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                    _hoisted_5
                                ], 8, _hoisted_4))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ]))
                    : (!loading_posts.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_6, "No posts."))
                        : (0, vue_2.createCommentVNode)("", true),
                (error.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_7, (0, vue_2.toDisplayString)(error.value), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                (loading_posts.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_8, "Loading..."))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
